import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-FEB5CPJZ1G'; // Your Google Analytics ID

export const initGA = () => {
  ReactGA.initialize(TRACKING_ID);
  //console.log('Google Analytics initialized with ID:', TRACKING_ID);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
  //console.log('Page view tracked:', path);
};

export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
  //console.log('Event tracked:', { category, action, label });
};

export const trackCustomEvent = (eventName, parameters = {}) => {
  ReactGA.event(eventName, parameters);
  //console.log('Custom event tracked:', eventName, parameters);
};
